// src/pages/admin/AdminReferrals.js
// P2-C (v1.158) : Admin — suivi du programme de parrainage.
// Maxula
import React, { useEffect, useState } from 'react';
import { FiUsers, FiGift, FiTrendingUp, FiDollarSign } from 'react-icons/fi';
import { toast } from 'react-toastify';
import { referralAPI } from '../../services/api';

const AdminReferrals = () => {
  const [rows, setRows] = useState([]);
  const [totals, setTotals] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    referralAPI.adminList()
      .then((r) => { setRows(r?.data?.data || []); setTotals(r?.data?.totals || null); })
      .catch(() => toast.error('Erreur de chargement'))
      .finally(() => setLoading(false));
  }, []);

  const name = (u) => u ? `${u.firstName || ''} ${u.lastName || ''}`.trim() || u.email : '—';

  return (
    <div className="p-6">
      <h1 className="text-3xl font-bold text-gray-900 mb-2">Parrainages</h1>
      <p className="text-gray-500 mb-5">Suivi du programme : invitations, conversions et récompenses versées.</p>

      {totals && (
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 mb-6">
          <div className="bg-white rounded-xl shadow p-4"><FiUsers className="text-primary-500 mb-1" /><div className="text-2xl font-bold">{totals.total}</div><div className="text-xs text-gray-500">Parrainages</div></div>
          <div className="bg-white rounded-xl shadow p-4"><FiGift className="text-primary-500 mb-1" /><div className="text-2xl font-bold">{totals.rewarded}</div><div className="text-xs text-gray-500">Récompensés</div></div>
          <div className="bg-white rounded-xl shadow p-4"><FiTrendingUp className="text-primary-500 mb-1" /><div className="text-2xl font-bold">{totals.conversionRate}%</div><div className="text-xs text-gray-500">Taux de conversion</div></div>
          <div className="bg-white rounded-xl shadow p-4"><FiDollarSign className="text-primary-500 mb-1" /><div className="text-2xl font-bold">{Number(totals.totalPaid).toFixed(2)} MAD</div><div className="text-xs text-gray-500">Récompenses versées</div></div>
        </div>
      )}

      <div className="bg-white rounded-xl shadow overflow-x-auto">
        {loading ? (
          <div className="p-10 text-center text-gray-400">Chargement...</div>
        ) : rows.length === 0 ? (
          <div className="p-10 text-center text-gray-400">Aucun parrainage pour le moment</div>
        ) : (
          <table className="w-full text-sm">
            <thead className="bg-gray-50 text-gray-600">
              <tr>
                <th className="text-left px-4 py-3 font-medium">Parrain</th>
                <th className="text-left px-4 py-3 font-medium">Filleul</th>
                <th className="text-left px-4 py-3 font-medium">Date</th>
                <th className="text-left px-4 py-3 font-medium">Statut</th>
                <th className="text-right px-4 py-3 font-medium">Récompense</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.id} className="border-t border-gray-100">
                  <td className="px-4 py-3">{name(r.referrer)}<div className="text-xs text-gray-400">{r.referrer?.email}</div></td>
                  <td className="px-4 py-3">{name(r.referee)}<div className="text-xs text-gray-400">{r.referee?.email}</div></td>
                  <td className="px-4 py-3 text-gray-500">{r.createdAt ? new Date(r.createdAt).toLocaleDateString('fr-FR') : ''}</td>
                  <td className="px-4 py-3">
                    <span className={`px-2.5 py-1 rounded-full text-xs font-semibold ${r.status === 'rewarded' ? 'bg-green-100 text-green-700' : 'bg-amber-100 text-amber-800'}`}>
                      {r.status === 'rewarded' ? 'Récompensé' : 'En attente'}
                    </span>
                  </td>
                  <td className="px-4 py-3 text-right font-semibold">{r.rewardAmount != null ? `${Number(r.rewardAmount).toFixed(2)} MAD` : '—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default AdminReferrals;
